var path = 'msi/layout/forbidden/forbidden.html';
var html = "<div class=\"og-message-main\" id=\"og-no-shipment-message\">\n  <p translate=\"NOT_A_SUBSCRIBER\"></p>\n  <a href=\"{{ 'URL_LEARN_MORE' | translate }}\" class=\"og-button\" translate=\"TEXT_LEARN_MORE\"></a>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;